import React from "react";

import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { MDBContainer } from "mdb-react-ui-kit";

export class Eventos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      eventos: []
    };
  }

  componentDidMount() {
    this.getEventos();
  }

  getEventos() {
    if(this.props.onLoading){
          this.props.onLoading(true);
    }

    doFetch("HAPK", "getAllEvents", null)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(JSON.stringify(data, null, 2));
        this.setState({ noticias: data.DATA });
      })
      .catch((error) => {
        console.error(
          "Error al obtener datos:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        if (this.props.onLoading) {
          this.props.onLoading(false);
        }
      });
  }

  render() {
    return (
      <MDBContainer>
        {this.state.eventos?.map((element, index) => (
          <MDBContainer>
            <div>
              <ul>
                <li>{element.titulo}</li>
              </ul>
            </div>
          </MDBContainer>
        ))}
      </MDBContainer>
    )
  }

};

export default Eventos;
